import React from 'react';
import { Icon } from '@sizeid/commons/components/SvgImage';

import CollapseArrowContainer from './styled/CollapseArrowContainer';

const CollapseArrow: React.FC<{ collapsed: boolean }> = ({ collapsed }) => (
  <CollapseArrowContainer>
    <Icon image="arrow" size="1em" rotation={collapsed ? -90 : 90} primary />
  </CollapseArrowContainer>
);

export default CollapseArrow;
